import { styled } from 'styled-components';

import { colors, transition } from '#/theme/theme';

export const ArrowNavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  width: calc(100% + 128px);
  max-width: calc(100vw - 16px);
  pointer-events: none;

  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ArrowNavigationButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0;
  justify-content: center;
  align-items: center;
  color: white;
  background: ${colors.brandBlue};
  border-radius: 50%;
  pointer-events: auto;
  transition: all ${transition};

  &[disabled] {
    opacity: 0.33;

    &:hover {
      background: ${colors.brandBlue};
    }
  }

  &:hover,
  &:focus {
    background: ${colors.brandGreen};
  }
`;
